<div class="row settings-nav-row">
  <div class="col-md-3">
    <h1
      class="settings-title"
      [ngClass]="{
        'dashboard-title': pageTitle == 'Data Configuration Settings'
      }"
    >
      {{ pageTitle }}
    </h1>
  </div>
  <span *ngIf="settingsNavItemData.length >= 2">
    <div
      class="col-md-2 nav-element-cols"
      *ngFor="let navElement of settingsNavItemData"
    >
      <settings-nav-elements
        [navElement]="navElement"
        (navElementEvent)="navClicked($event)"
      ></settings-nav-elements>
      <div class="triangle-element" *ngIf="navElement.selected"></div>
      <div class="triangle-element-fill" *ngIf="navElement.selected"></div>
    </div>
  </span>
  <div class="col-md-6 spacer-col" *ngIf="settingsNavItemData.length < 2"></div>
  <div class="col-md-3 settings-add" *ngIf="!isStarterUser">
    <p class="add-user-description">
      Have someone else who will help configure your metrics? Invite them to
      help!
    </p>
    <button
      mat-raised-button
      class="add-user-btn green-btn"
      (click)="goToAddUser()"
    >
      <img
        [src]="getFullImagePath('add_user')"
        class="settings-add-user-icon"
      />
      ADD USER
    </button>
  </div>
</div>
